import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";

export default function PremiumStatus({ mode }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh, user } = useAuth();
  const [state, setState] = useState({ status: "checking", tries: 0 });

  useEffect(() => {
    if (mode === "cancel") { setState({ status: "cancelled" }); return; }
    const sid = params.get("session_id");
    if (!sid) { setState({ status: "error" }); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/premium/status/${sid}`);
        if (data.payment_status === "paid") {
          await refresh();
          toast.success("Premium attivato!");
          setState({ status: "paid" });
          return;
        }
      } catch (e) {
        console.debug("premium status poll failed:", e);
      }
      if (tries < 20) setTimeout(poll, 2000);
      else setState({ status: "timeout" });
    };
    poll();
  }, [mode, params, refresh]);

  const isChecking = state.status === "checking";
  const paid = state.status === "paid";
  return (
    <div className="mx-auto max-w-md px-4 py-20 text-center">
      <div className="ga-card p-10">
        {isChecking && <>
          <Loader2 className="w-10 h-10 mx-auto animate-spin text-slate-500" />
          <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Verifica pagamento...</h1>
          <p className="mt-2 text-sm text-slate-600">Ci vogliono pochi secondi.</p>
        </>}
        {paid && <>
          <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-600" />
          <h1 className="mt-4 font-display text-3xl font-extrabold text-slate-900">Sei Premium!</h1>
          <p className="mt-2 text-sm text-slate-600">
            {user?.role === "supplier"
              ? "Zero commissione sulle transazioni e boost visibilità nelle aste attivi."
              : "Analytics avanzate e ordini illimitati sbloccati."}
          </p>
          <Button onClick={() => navigate(user?.role === "supplier" ? "/fornitore" : "/ristorante")} className="mt-6 ga-btn-primary rounded-full" data-testid="premium-back-button">Vai alla dashboard</Button>
        </>}
        {state.status === "cancelled" && <>
          <XCircle className="w-12 h-12 mx-auto text-slate-400" />
          <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Pagamento annullato</h1>
          <p className="mt-2 text-sm text-slate-600">Puoi riprovare quando vuoi.</p>
          <Button onClick={() => navigate(user?.role === "supplier" ? "/fornitore" : "/ristorante")} variant="outline" className="mt-6 rounded-full" data-testid="premium-back-button">Torna alla dashboard</Button>
        </>}
        {state.status === "timeout" && <>
          <XCircle className="w-12 h-12 mx-auto text-amber-500" />
          <h1 className="mt-4 font-display text-2xl font-bold text-slate-900">Elaborazione in corso</h1>
          <p className="mt-2 text-sm text-slate-600">Riceverai conferma a breve. Se non vedi lo stato aggiornato, ricarica la dashboard.</p>
          <Button onClick={() => navigate(user?.role === "supplier" ? "/fornitore" : "/ristorante")} className="mt-6 rounded-full" data-testid="premium-back-button">Vai alla dashboard</Button>
        </>}
      </div>
    </div>
  );
}
